import React from 'react';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Controller } from 'react-hook-form';
import { FormInputProps } from './FormInputProps';

/**
 * Single checkbox input component.
 * Supports both labeled (FormControlLabel) and unlabeled (standalone) variants.
 */
export const FormInputCheckbox = ({ name, control, label, disabled, readOnly }: FormInputProps) => {
  const theme = useTheme();

  return label ? (
    <FormControl>
      <FormControlLabel
        control={
          <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                color="primary"
                checked={!!value}
                onChange={onChange}
                disabled={disabled || readOnly}
                sx={{
                  color: theme.palette.primary.main,
                  '&.Mui-checked': {
                    color: theme.palette.primary.main,
                  },
                  '&.Mui-disabled': {
                    color: theme.palette.action.disabled,
                  },
                  '&.Mui-checked.Mui-disabled': {
                    color: theme.palette.action.disabled,
                  },
                }}
              />
            )}
          />
        }
        label={label}
        disabled={disabled || readOnly}
      />
    </FormControl>
  ) : (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Checkbox
          color="primary"
          checked={!!value}
          onChange={onChange}
          disabled={disabled || readOnly}
          sx={{
            color: theme.palette.primary.main,
            '&.Mui-checked': {
              color: theme.palette.primary.main,
            },
            '&.Mui-disabled': {
              color: theme.palette.action.disabled,
            },
            '&.Mui-checked.Mui-disabled': {
              color: theme.palette.action.disabled,
            },
          }}
        />
      )}
    />
  );
};
